import React, { useEffect, useState } from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Chip } from '@mui/material'
import Heatmap from 'react-heatmap-grid'
import { Button } from 'src/Common/ui/button'
import * as IssueTypes from 'src/Entities/IssueTypes'
import SaveCancelButton from 'src/Common/ui/SaveCancelButton'
import { CHIP_VERY_HIGH, CHIP_VERY_LOW } from 'src/Entities/IssueTypes'

const IssueHeatMapDialog = ({
    open, handleClose, initialRiskScore, setinitialRiskScore, heatMapSelection, edit, type = 'RISK'
}) => {
    const [ selectedBox, setSelectedBox ] = useState(null)
    const [ riskValue, setRiskValue ] = useState({})

    useEffect(() => {
        setRiskValue({
            ...riskValue,
            impact: initialRiskScore?.impact,
            impactOfRisk: initialRiskScore?.impactOfRisk,
            Probability: initialRiskScore?.Probability,
            RiskScore: initialRiskScore?.RiskScore
        })
    }, [initialRiskScore])
    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === CHIP_VERY_LOW) {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === 'Low') {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === 'Medium') {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === 'High') {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === CHIP_VERY_HIGH) {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }
    const handleThreeCrossBoxClick = (x, y) => {
        const RiskScore = IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[y][x]?.value
        const impact = x > 0 ? IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[y][0]?.value : RiskScore
        const Probability = y < IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS.length - 1
            ? IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS[IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS.length - 1][x]?.value
            : RiskScore

        setRiskValue({
            ...riskValue,
            impact: `${IssueTypes.Y_LABLES_THREE_CROSS[IssueTypes.IMPACT_VALUE_THREE_CROSS.indexOf(impact)]}`,
            Probability: `${IssueTypes.X_LABLES_THREE_CROSS[IssueTypes.PROBABILITY_VALUE_THREE_CROSS.indexOf(Probability)]}`,
            RiskScore: `${
            (RiskScore === IssueTypes.ISSUE_SCORE_ONE || RiskScore === IssueTypes.ISSUE_SCORE_TWO)
                ? IssueTypes.ISSUE_LEVEL_LOW
                : (RiskScore === IssueTypes.ISSUE_SCORE_THREE || RiskScore === IssueTypes.ISSUE_SCORE_FOUR)
                    ? IssueTypes.ISSUE_LEVEL_MEDIUM
                    : (RiskScore === IssueTypes.ISSUE_SCORE_SIX || RiskScore === IssueTypes.ISSUE_SCORE_NINE) &&
                        IssueTypes.ISSUE_LEVEL_VERY_HIGH
        }`
        })
    }

    function getLabelByScore (score) {
        if (score >= 1 && score <= 5) return 'Very Low'
        if (score >= 6 && score <= 10) return 'Low'
        if (score >= 11 && score <= 15) return 'Medium'
        if (score >= 16 && score <= 20) return 'High'
        if (score >= 21 && score <= 25) return 'Very High'
        return 'Unknown'
    }

    const handleBoxClick = (x, y) => {
        const RiskScore = IssueTypes.ISSUE_SCROING_DATA[y][x]?.value
        const impact = x < IssueTypes.ISSUE_SCROING_DATA[0].length - 1
            ? IssueTypes.ISSUE_SCROING_DATA[y][IssueTypes.ISSUE_SCROING_DATA[0].length - 1]?.value
            : RiskScore

        const Probability = y < IssueTypes.ISSUE_SCROING_DATA.length - 1 ? IssueTypes.ISSUE_SCROING_DATA[IssueTypes.ISSUE_SCROING_DATA.length - 1][x]?.value : RiskScore

        setRiskValue({
            ...riskValue,
            impact: getLabelByScore(impact),
            Probability: `${IssueTypes.xLabels[IssueTypes.PROBABILITY_VALUE.indexOf(Probability)]}`,
            RiskScore: `${
     [ IssueTypes.ISSUE_SCORE_ONE, IssueTypes.ISSUE_SCORE_TWO, IssueTypes.ISSUE_SCORE_SIX ].includes(RiskScore)
         ? IssueTypes.ISSUE_LEVEL_VERY_LOW
         : [ IssueTypes.ISSUE_SCORE_THREE, IssueTypes.ISSUE_SCORE_FOUR, IssueTypes.ISSUE_SCORE_FIVE,
             IssueTypes.ISSUE_SCORE_SEVEN, IssueTypes.ISSUE_SCORE_EIGHT,
             IssueTypes.ISSUE_SCORE_ELEVEN, IssueTypes.ISSUE_SCORE_TWELVE, IssueTypes.ISSUE_SCORE_SIXTEEN ]
             .includes(RiskScore)
             ? IssueTypes.ISSUE_LEVEL_LOW
             : [ IssueTypes.ISSUE_SCORE_NINE, IssueTypes.ISSUE_SCORE_THIRTEEN, IssueTypes.ISSUE_SCORE_SEVENTEEN ]
                 .includes(RiskScore)
                 ? IssueTypes.ISSUE_LEVEL_MEDIUM
                 : [ IssueTypes.ISSUE_SCORE_TEN, IssueTypes.ISSUE_SCORE_FOURTEEN, IssueTypes.ISSUE_SCORE_FIFTEEN,
                     IssueTypes.ISSUE_SCORE_EIGHTEEN, IssueTypes.ISSUE_SCORE_NINETEEN,
                     IssueTypes.ISSUE_SCORE_TWENTY_TWO, IssueTypes.ISSUE_SCORE_TWENTY_THREE ]
                     .includes(RiskScore)
                     ? IssueTypes.ISSUE_LEVEL_HIGH
                     : [ IssueTypes.ISSUE_SCORE_TWENTY, IssueTypes.ISSUE_SCORE_TWENTY_ONE,
                         IssueTypes.ISSUE_SCORE_TWENTY_FOUR, IssueTypes.ISSUE_SCORE_TWENTY_FIVE ]
                         .includes(RiskScore)
                         ? IssueTypes.ISSUE_LEVEL_VERY_HIGH
                         : ''
   }`

        })
    }

    const handleSave = () => {
        setinitialRiskScore(riskValue)
        handleClose()
    }
    return (
        <Dialog
            maxWidth="md"
            open={open}
            onClose={handleClose}
        >
            <Box >
                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>{type === 'RISK' ? 'Choose Risk Score' : 'Choose Issue Score'}</div>
                </DialogTitle>
                <DialogContent>
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: '45%' }}>
                            <div style={{ height: '90%', display: 'flex', flexDirection: 'row' }}>
                                <img src='/Assets/Priority.svg' style={{ height: '260px', marginTop: '3rem' }} alt="Impact" />
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    {heatMapSelection
                                        ? <Heatmap
                                            xLabels={IssueTypes.xLabels?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                            yLabels={IssueTypes.yLabels.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                            xLabelsLocation={'bottom'}
                                            xLabelWidth={50}
                                            data={IssueTypes.ISSUE_SCROING_DATA}
                                            squares
                                            height={45}
                                            onClick={(x, y) => {
                                                edit && handleBoxClick(x, y)
                                                edit && setSelectedBox({ x, y })
                                            }}
                                                                                                      title={(value) => value?.value ?? ""}

                                            cellStyle={(background, value, min, max, data, x, y) => ({
                                                fontSize: '12.5px',
                                                backgroundColor: value?.color,
                                                color: '#fff',
                                                border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                            })}
                                        // cellRender={value => value && <div>{value.value}</div>}
                                        />
                                        : <Heatmap
                                            xLabels={IssueTypes.X_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px' }} >{dt}</p>)}
                                            yLabels={IssueTypes.Y_LABLES_THREE_CROSS?.map((dt, indedx) => <p key={indedx} style={{ fontSize: '10px', marginLeft: '-50px' }} >{dt}</p>)}
                                            xLabelsLocation={'bottom'}
                                            xLabelWidth={50}
                                            data={IssueTypes.ISSUE_SCROING_DATA_THREE_CROSS}
                                            squares
                                            height={45}
                                            onClick={(x, y) => {
                                                edit && handleThreeCrossBoxClick(x, y)
                                                edit && setSelectedBox({ x, y })
                                            }}
                                                                                                      title={(value) => value?.value ?? ""}

                                            cellStyle={(background, value, min, max, data, x, y) => ({
                                                fontSize: '12.5px',
                                                backgroundColor: value?.color,
                                                color: '#fff',
                                                border: selectedBox && selectedBox.x === x && selectedBox.y === y ? '7px solid #ffffff6e' : 'none'
                                            })}
                                        />}
                                </div>
                            </div>
                            <img src='/Assets/Severity.svg' style={{ paddingLeft: '60px', marginLeft: '6px' }} alt="Impact" />
                        </div>
                        <span style={{
                            display: 'inline-block',
                            width: '2px',
                            backgroundColor: 'hsl(var(--primary-foreground))',
                            margin: ' 0 10px',
                            height: ' 22em'
                        }} />
                        <div style={{ width: '40%', marginLeft: '1rem', marginTop: '2rem', display: 'flex', flexDirection: 'column' }}>
                            <div className='mb-1' >
                                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '3.5rem', justifyContent: 'center', alignItems: 'center', fontSize: '13px' }}>
                                    <p style={{ fontWeight: 'bold', marginRight: '1rem', fontSize: '12px', whiteSpace: 'nowrap' }}>Issue Level</p>
                                    {heatMapSelection
                                        ? IssueTypes.ISSUE_RATINNG?.map((data, ind) => {
                                            return (
                                                <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px', whiteSpace: 'nowrap', padding: '2px' }} key={ind} >{data?.title}</div>
                                            )
                                        })
                                        : IssueTypes.ISSUE_RATINNG_THREE_CROSS?.map((data, ind) => {
                                            return (
                                                <div style={{ width: 65, border: '0.5px solid black', color: '#fff', textAlign: 'center', backgroundColor: data?.color, fontSize: '12px', whiteSpace: 'nowrap', padding: '2px' }} key={ind} >{data?.title}</div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="max-w-30 mb-7 block font-medium">
                                    <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                        Priority :
                                    </h4>
                                    <span className='cursor-pointer'>
                                        {riskValue?.impact || ''}
                                    </span>
                                </div>
                                <div className="max-w-30 mb-7 font-medium">
                                    <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))' }}>
                                    Severity :
                                    </h4>
                                    <span className='cursor-pointer'>
                                        {riskValue?.Probability || ''}
                                    </span>
                                </div>
                                <div className=" max-w-30 mb-7 font-medium">
                                    <h4 style={{ display: 'inline-block', marginRight: '0.2rem', color: 'hsl(var(--primary))', whiteSpace: 'nowrap' }}>
                                    Issue Level :
                                    </h4>
                                    <span>
                                        <Chip
                                            key={riskValue?.RiskScore || ''}
                                            label={riskValue?.RiskScore || ''}
                                            sx={{
                                                width: '100px',
                                                color: 'hsl(var(--foreground))',
                                                backgroundColor: chipColorStyle(riskValue?.RiskScore)
                                            }}

                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>

                {edit
                    ? <DialogActions style={{ width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>

                        <div className='d-flex content-end'>
                            <SaveCancelButton handleCancel={handleClose} handleSave={handleSave} />
                        </div>
                    </DialogActions>
                    : <DialogActions>
                        <Button
                            variant='outline'
                            style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                            onClick={() => { handleClose() }}
                        >
                    Cancel
                        </Button>
                    </DialogActions>
                }
            </Box>
        </Dialog>
    )
}

export default IssueHeatMapDialog
